import { Card, icons, useModal, sizing } from '@chillibean/component-library';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import { AdminHeroBox } from '../../../../../HeroBox/AdminHeroBox/AdminHeroBox';
import { AdminList } from '../../components/container';
import { FooterButtons } from '../../components/container/FooterButtons';
import { StudyProcedureRoleDefinitionModal } from './components/container';

export function ContributorRolesPage() {
  // HOOKS
  // Store
  const { data: protocol, loading } = useSelector((state) => state.protocolReducer.protocol);
  // Custom
  const {
    closeModal: closeContributorRoleModal,
    data: selectedContributorRole,
    modalOpen: contributorRoleModalOpen,
    openModal: openContributorRoleModal,
  } = useModal();

  // METHODS
  const onClick = (id) => {
    if (protocol.locked) return;

    const contributorRoleToSelect = protocol.studyProcedureRoleDefinitions.find(
      (contributorRole) => contributorRole.id === id,
    );
    openContributorRoleModal(contributorRoleToSelect);
  };

  const roleSubHeader = (roleDefinition) => {
    if (roleDefinition.notify) return 'Receives Notifications';

    return '';
  };

  return (
    <>
      <StudyProcedureRoleDefinitionModal
        existingRoles={protocol?.studyProcedureRoleDefinitions.map((roleDefinition) => roleDefinition.role.id)}
        onClose={closeContributorRoleModal}
        onSuccess={closeContributorRoleModal}
        studyProcedureRoleDefinition={selectedContributorRole}
        visible={contributorRoleModalOpen}
      />
      <Container>
        <AdminHeroBox
          button={{
            disabled: protocol?.locked,
            loading: false,
            onClick: () => openContributorRoleModal(),
            text: 'Create New',
          }}
          content="Contributors are members of the study team who need to be known for an assessment. Instead of having an Info Field for Clinical Evaluator, you can now make Clinical Evaluator a Contributor. Contributors are linked to User Roles."
          disabled={protocol?.locked}
          header="Contributor Role List"
          icon={icons.baselineFormatBulletList}
          loading={loading}
          subHeader="Contributor Roles"
        />
        {!loading && !protocol?.studyProcedureRoleDefinitions.length && (
          <Card disabled>No contributor roles defined</Card>
        )}
        {(loading || Boolean(protocol?.studyProcedureRoleDefinitions.length)) && (
          <AdminList
            elements={
              protocol?.studyProcedureRoleDefinitions.map((roleDefinition) => ({
                ...roleDefinition.listParams({
                  locked: protocol?.locked,
                  onClick: onClick,
                }),
                subHeader: roleSubHeader(roleDefinition),
              })) || []
            }
            loading={loading}
          />
        )}
        <FooterButtons />
      </Container>
    </>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${sizing.medium};
`;

export default ContributorRolesPage;
